import React, {FC, useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {fetchData, formatNumber, getTranslatedValue, toasterrormsg} from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'
import {VehicleDetailsHeader} from './VehicleDetailsHeader'
import Fancybox from '../Fancybox'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
const VehicleOverview: FC = () => {
let t = Tr()
  const location = useLocation()
  const vehicleId = (location.state as any)?.vehicleId || ''
  const [vehicleDetails, setVehicleDetails] = useState([])
  const lang = useLang()

  // vehicle Details api call
  const vehicleDetailsApiCall = async () => {
    var param: any = {
      vehicleId: vehicleId,
    }
    var response: any = await fetchData('vendor/public/vehicleDetail', param)

    if (response.status == '200') {
      setVehicleDetails(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
    // Other options...
  }
  useEffect(() => {
    vehicleDetailsApiCall()
  }, [])
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Cars Overview")}</PageTitle>
      <ToastContainer />
      <VehicleDetailsHeader />
      {vehicleDetails.map((vehicle: any, index: any) => {
        return (
          <div className='form' key={index}>
            {/* <!--begin::Card--> */}
            <div className='card'>
              {/* <!--begin::Card header--> */}
              <div className='card-header'>
                {/* <!--begin::Card header--> */}
                <div className='card-title fs-3 fw-bold'>{t("Basic Details")}</div>
                {/* <!--end::Card header--> */}
              </div>
              {/* <!--end::Card header--> */}
              {/* <!--begin::Card body--> */}
              <div className='card-body'>
                {vehicle['en_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Vehicle Name (English)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: vehicle['en_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {vehicle['ru_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Vehicle Name (Russian)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: vehicle['ru_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {vehicle['uz_name'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Vehicle Name (Uzbek)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: vehicle['uz_name']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {vehicle['carCategory'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Car Category")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['carCategory'].map((carCategory: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,carCategory, "_name")}
                                {index !== vehicle['carCategory'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {vehicle['carType'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Car Type")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['carType'].map((carType: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,carType, "_name")}
                                {index !== vehicle['carType'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {vehicle['seatsDetail'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Number Of Seats")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['seatsDetail'].map((seats: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,seats, "_name")}
                                {index !== vehicle['seatsDetail'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {vehicle['price'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Car Price (By Day)")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                          {formatNumber(parseFloat(vehicle['price']))}{' '}
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {vehicle['gear_shift'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Gear Shift")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex flex-column'>
                          <div className=' fw-semibold text-gray-600 mt-3'>
                            <div dangerouslySetInnerHTML={{__html: vehicle['gear_shift']}}></div>
                          </div>
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {vehicle['fuelPolicy'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Fuel Policy")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['fuelPolicy'].map((fuel: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,fuel, "_name")}
                                {index !== vehicle['fuelPolicy'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                {vehicle['specs'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Car Specs")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['specs'].map((specs: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,specs, "_name")}
                                {index !== vehicle['specs'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}
                {vehicle['carbootspace'] ? (
                  <>
                    {/* <!--begin::Row--> */}
                    <div className='row mb-8'>
                      {/* <!--begin::Col--> */}
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Car Boot Space")}</div>
                      </div>
                      {/* <!--end::Col--> */}

                      {/* <!--begin::Col--> */}
                      <div className='col-xl-9'>
                        {/* <!--begin::Progress--> */}
                        <div className='d-flex'>
                          {vehicle['carbootspace'].map((bootspace: any, index: any) => {
                            return (
                              <div key={index} className='fw-semibold text-gray-600 mt-3'>
                                {getTranslatedValue( lang,bootspace, "_name")}
                                {index !== vehicle['carbootspace'].length - 1 ? ', ' : ''}
                              </div>
                            )
                          })}
                        </div>
                        {/* <!--end::Progress--> */}
                      </div>
                      {/* <!--end::Col--> */}
                    </div>
                    {/* <!--end::Row--> */}
                  </>
                ) : (
                  ''
                )}

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Car Policy")}</div>
                </div>

                {vehicle['isUnlimited'] == 1 ? (
                  <>
                    <div className='row mb-8'>
                      <div className='col-xl-3'>
                        <div className='fs-6 fw-bold mt-2 mb-3'>{t("Mileage")}</div>
                      </div>
                      <div className='col-xl-9'>
                        <div className='d-flex flex-column'>
                          <div className='fw-semibold text-gray-600 mt-3'>{t("Unlimited")}</div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {vehicle['mileageType'] ? (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>{t("Mileage Type")}</div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              <div dangerouslySetInnerHTML={{__html: vehicle['mileageType']}}></div>
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    ) : (
                      ''
                    )}

                    {vehicle['mileage'] ? (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>{t("Mileage (Km)")} </div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                              <div dangerouslySetInnerHTML={{__html: vehicle['mileage']}}></div>
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    ) : (
                      ''
                    )}

                    {vehicle['ifExceedes'] ? (
                      <div className='row mb-8'>
                        {/* <!--begin::Col--> */}
                        <div className='col-xl-3'>
                          <div className='fs-6 fw-bold mt-2 mb-3'>{t("If Exceeds")}</div>
                        </div>
                        {/* <!--end::Col--> */}

                        {/* <!--begin::Col--> */}
                        <div className='col-xl-9'>
                          {/* <!--begin::Progress--> */}
                          <div className='d-flex flex-column'>
                            <div className=' fw-semibold text-gray-600 mt-3'>
                            {formatNumber(parseFloat(vehicle['ifExceedes']))}{' '}
                            </div>
                          </div>
                          {/* <!--end::Progress--> */}
                        </div>
                        {/* <!--end::Col--> */}
                      </div>
                    ) : (
                      ''
                    )}
                    {/* <!--end::Row--> */}
                  </>
                )}

                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                  <div className='fs-3 fw-bold mb-5 '>{t("Car Photos")}</div>
                </div>
                {vehicle['images'].length != 0 ? (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 7--> */}
                    <div className='card card-flush h-xl-100'>
                      <div className='pt-7'>
                        <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                          {vehicle['images'].map((images: any, index: any) => {
                            return (
                              <>
                                <Fancybox options={opts}>
                                  {/* <!--begin::Col--> */}
                                  <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                    {/* <!--begin::Overlay--> */}
                                    <a
                                      data-fancybox='gallery'
                                      className='d-block overlay'
                                      data-fslightbox='lightbox-hot-sales'
                                      href={images['mediaPath']}
                                    >
                                      <div
                                        className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                        style={{
                                          height: '266px',
                                          backgroundImage: `url('${images['mediaPath']}')`,
                                        }}
                                      ></div>
                                      {/* <!--end::Image--> */}

                                      {/* <!--begin::Action--> */}
                                      <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                        <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                      </div>
                                      {/* <!--end::Action-->       */}
                                    </a>
                                    {/* <!--end::Overlay-->          */}
                                  </div>
                                  {/* <!--end::Col-->      */}
                                </Fancybox>
                              </>
                            )
                          })}
                        </div>
                        {/* <!--end::Row--> */}
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Engage widget 7--> */}
                  </div>
                ) : (
                  <div className='col-xl-12'>
                    {/* <!--begin::Engage widget 1--> */}
                    <div className='card h-md-100' dir='ltr'>
                      {/* <!--begin::Body--> */}
                      <div className='card-body d-flex flex-column flex-center'>
                        {/* <!--begin::Heading--> */}
                        <div className='mb-2'>
                          {/* <!--begin::Illustration--> */}
                          <div className='py-10 text-center'>
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                              className='theme-light-show h-125px'
                              alt=''
                            />
                            <img
                              src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                              className='theme-dark-show h-125px'
                              alt=''
                            />
                          </div>
                          {/* <!--end::Illustration--> */}
                        </div>
                        {/* <!--end::Heading--> */}
                      </div>
                      {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Engage widget 1--> */}
                  </div>
                )}
              </div>
          
            </div>
            {/* <!--end::Card--> */}
          </div>
        )
      })}
    </>
  )
}

export {VehicleOverview}
